import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ModalController } from '@ionic/angular';
import { id } from '@swimlane/ngx-charts';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false, showError: true},
    },
  ],
})
export class StepperComponent implements OnInit {
 

  @Input() Texto = "Proceso finalizado";
  @Input() Img: "bien" | "mal" = "bien"

  @ViewChild("stepper") stepper: MatStepper;
  @Input() Pasos = []
  Indice = 0

  constructor(private _formBuilder: FormBuilder, private utilidades: UtilidadesService, 
    public modal: ModalController) { }

  Formularios = []

  ngOnInit() {
    for(let i of this.Pasos){
      this.Formularios.push(
        {
          "Nombre": i,
          "Formulario": this._formBuilder.group({
            control: ['', Validators.required]
          })
        }
      )
    }

    this.utilidades.stepper$.subscribe((resp:any) =>{
      this.Texto = resp.Mensaje
      if(resp.Aviso=="Fin" ){
        if(resp.Tipo=="Exito"){
          this.Img="bien"
        }else{
          this.Img="mal"
        }
        console.log("lkkj")
        
      }
      this.Siguiente(resp)
    })

  }

  Siguiente(resp){
    if(this.Indice<this.Formularios.length){
      if(resp.Tipo == "Exito"){
        this.Formularios[this.Indice].Formulario.patchValue({
          control: 'Completado'
        })
      }
      this.Indice += 1
      
    }else{
      setTimeout(() => {
        document.getElementById("cdiv").scrollTo({"top": 3000, "behavior": "smooth"})
        console.clear()
      }, 300);
    }

    this.stepper.next()
  }
}
